import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { CoreModule } from './core/core.module';
import { environment } from 'src/environments/environment';
// import { HttpClientModule } from '@angular/common/http';
import { provideHttpClient } from '@angular/common/http';
import { initializeApp } from 'firebase/app';
import { MatIconRegistry } from '@angular/material/icon';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SharedModule } from './shared/shared.module';
import { svgIcons } from './svgs';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { EffectsModule } from "@ngrx/effects";
import { RouterModule } from "@angular/router";
import { AuthReducer } from "./states/auth/auth.reducer";
import { AuthEffects } from "./states/auth/Auth.effects";
import { StoreReducer } from "./states/Store/store.reducer";
import { StoreEffects } from "./states/Store/store.effects";
import { ItemReducer } from "./states/Item/item.reducer";
import { ItemEffects } from "./states/Item/item.effects";
import { LocationReducer } from "./states/Location/location.reducer";
import { LocationEffects } from "./states/Location/location.effects";
import { AppointmentReducer } from "./states/Appointment/appointment.reducer";
import { AppointmentEffects } from "./states/Appointment/appointment.effects";
import { StudioReducer } from "./states/Studio/studio.reducer";
import { StudioEffects } from "./states/Studio/studio.effects";
import { RootReducer } from "./states/Root/root.reducer";
import { RootEffects } from "./states/Root/root.effects";
import { OrderEffects } from './states/Order/order.effects';
import { OrderReducer } from './states/Order/order.reducer';
import { StarRatingModule } from "angular-star-rating";
import { CountryStateCities } from './shared/interfaces';
import { ItemCategoryEffects } from './states/ItemCategory/ItemCategory.effects';
import { ItemCategoryReducer } from './states/ItemCategory/ItemCategory.reducer';

initializeApp(environment.firebaseConfig);

@NgModule({
	declarations: [AppComponent],
	imports: [
		StarRatingModule.forRoot(),
		CoreModule.forRoot(),
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		// HttpClientModule,
		SharedModule.forRoot(),
		FormsModule,
		ReactiveFormsModule,
		StoreModule.forRoot({
			'Auth': AuthReducer,
			'Store': StoreReducer,
			'Item': ItemReducer,
			'ItemCategory': ItemCategoryReducer,
			'Location': LocationReducer,
			'Appointment': AppointmentReducer,
			'Studio': StudioReducer,
			'Root': RootReducer,
			'Order': OrderReducer,
		} as ActionReducerMap<any, any>),
		EffectsModule.forRoot([
			AuthEffects,
			StoreEffects,
			ItemEffects,
			ItemCategoryEffects,
			LocationEffects,
			AppointmentEffects,
			StudioEffects,
			RootEffects,
			OrderEffects,
		]),
	],
	exports: [
		ReactiveFormsModule,
		RouterModule,
	],
	providers: [CountryStateCities, provideHttpClient()],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
	constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
		// check https://materialdesignicons.com for available icons
		// matIconRegistry.addSvgIconSet(
		//   domSanitizer.bypassSecurityTrustResourceUrl('assets/mdi.svg')
		// );
		svgIcons.forEach((name) => {
			matIconRegistry.addSvgIcon(
				name,
				domSanitizer.bypassSecurityTrustResourceUrl(`assets/svgs/${name}.svg`)
			);
		});
	}
}
